module.exports = __webpack_public_path__ + "static/media/address10.740da33a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/andimar/favoriteDestinations/address10.jpg
// module id = 296
// module chunks = 0